export default __webpack_public_path__ + "static/Silicon Chip-7cdf123eeeeb2c1c2b13616759ad0c6e.png";